
class EnvHelper {
    public static isDevelopmentQa = () : boolean => {
        return ENV_NAME === 'qa';
    };

    public static getEnvName = () : string => {
        if (ENV_NAME === 'production') {
            return 'Technical OPS';
        } else if (ENV_NAME === 'qa') {
            return 'Technical OPS QA';
        } else if (ENV_NAME === 'development') {
            return 'Technical OPS DEV';
        } else {
            return 'Technical OPS ENV NOT FOUND';
        }
    };
}

export default EnvHelper;